import { useTranslation } from "react-i18next";
import NavBar from "../components/NavBar";
import BackgroundImage from "../components/BackgroundImage";
import Footer from "../components/Footer";
import TransLink from "../components/TransLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLightbulb,
  faPhone,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";

export default function FAQs() {
  const { t } = useTranslation();

  return (
    <>
      <div className="page-wrapper">
        <BackgroundImage />
        <NavBar />
        <div className="transparency-wrapper">
          <div className="secondary-page-wrapper breathe">
            <div className="section-title-centered neon-glow">
              Frequently Asked Questions
            </div>

            <div className="section-text-main text-left padding-vertical">
              I just need a mobile app/firmware/website. Are you able to help?
            </div>
            <div className="section-text-secondary">
              <TransLink
                t="faqsAnswer1"
                textStyle="section-text-secondary"
                linkStyle="project-link"
              />
            </div>

            <div className="section-text-main text-left padding-vertical">
              Are you a solo developer or are you part of an agency?
            </div>
            <div className="section-text-secondary">
              I work solo. No subcontractors, no outsourcing, no surprise devs
              from random places. When you hire me, I’m the one doing the work.
              Period. That doesn’t mean I can’t work with a team if you already
              have one. And if anything needs to be outsourced, like PCB
              manufacturing or casing, that will be completely transparent and
              included in the offer.
            </div>

            <div className="section-text-main text-left padding-vertical">
              Do you have the tools to actually test hardware?
            </div>
            <div className="section-text-secondary">
              Yes, I’ve got the full lab setup: oscilloscope, power profiler,
              various development kits (nRF, ESP, STM, MSP, Arduino, Raspberry
              Pi), and soldering station. All the necessary equipment to test,
              validate, and debug hardware precisely.
            </div>

            <div className="section-text-main text-left padding-vertical">
              How much will this cost? How long will it take?
            </div>
            <div className="section-text-secondary">
              <TransLink
                t="faqsAnswer2"
                textStyle="section-text-secondary"
                linkStyle="project-link"
              />
            </div>

            <div className="section-text-main text-left padding-vertical">
              I’m not ready yet. Can I just get advice? Can you help me refine
              or plan my idea?
            </div>
            <div className="section-text-secondary">
              Definitely. Many clients come with rough concepts and I help shape
              them into a clear roadmap. From feasibility to feature
              prioritization and architecture, I’ll help you think it through
              before you build. Whether you’re early-stage, stuck, or just
              exploring, I’ll help you define things in a tangible way and move
              forward.
            </div>

            <div className="section-text-main text-left padding-vertical">
              Where are you based? Will time zones be a problem?
            </div>
            <div className="section-text-secondary">
              I’m in Uruguay, South America (GMT-3) but I work well with clients
              across the US and Europe. Async-friendly, flexible with calls, and
              always communicative. I adapt to your rhythm.
            </div>

            <div className="section-text-main text-left padding-vertical">
              What kind of projects have you done?
            </div>
            <div className="section-text-secondary">
              <TransLink
                t="faqsAnswer3"
                textStyle="section-text-secondary"
                linkStyle="project-link"
              />
            </div>

            <div className="section-text-main text-left padding-vertical">
              How do we start?
            </div>
            <div className="section-text-secondary text-left">
              Easy:
              <p className="section-text-secondary text-left breathe">
                <FontAwesomeIcon
                  icon={faLightbulb}
                  className="quote-icon tab"
                />
                <TransLink
                  t="faqHowDoWeStart1"
                  textStyle="section-text-secondary text-left"
                  linkStyle="project-link"
                />
              </p>
              <p className="section-text-secondary text-left breathe">
                <FontAwesomeIcon icon={faPhone} className="quote-icon tab" />{" "}
                {t("faqHowDoWeStart2")}
              </p>
              <p className="section-text-secondary text-left breathe">
                <FontAwesomeIcon
                  icon={faHandshake}
                  className="quote-icon tab"
                />{" "}
                {t("faqHowDoWeStart3")}
              </p>
            </div>
          </div>
          <div className="cta-button-secondary-wrapper">
            <Link
              to="/quote"
              className="cta-button-secondary"
              onClick={() => trackCTA("faqs-cta-bottom")}
            >
              {t("aboutCTA2")}
            </Link>
          </div>
          <div className="bottom-space"></div>
          <Footer />
        </div>
      </div>
    </>
  );
}
